import { VTSVehicleModel } from './../models/vehicle.model';
import { Http } from '@angular/http';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { IKeyValueInterface, Marker } from './../../shared/config';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { VehicleService } from '../models/vehicle.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';
import { Location } from '@angular/common';



@Component({
  selector: 'wego-vtsvehicle-update',
  template: require('../views/vtsvehicle-update.component.html'),
  providers: [VehicleService],
})
export class VtsVehicleUpdateComponent implements OnInit, OnDestroy {
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  private vehicleMasterHashId: string;
  private sub: any;
  submitted = false;
  DataListModel: DataListModel;
  model: VTSVehicleModel;
  apiResponse: IAPIResponse;
  //vehicleList: VehicleModel[];
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  instanceList: any;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlVehicleList: string;
  errorGeoLocationAddress: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  isLoading: boolean;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  obuTypeList: any;
  public fileListQuer: string[] = [];

  @ViewChild('successPopup') public successPopup: any;

  constructor(private vehicleService: VehicleService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private http: Http,
    private locationService: Location) {
  }

  OnLicencePlatChange(newValue: any) {
    let ltag: any;
    ltag = this.formatLicenceTag(newValue);
    console.log(newValue, this.model.licenceTag);
    this.model.licenceTag = ltag;
  }

  OnPhoneNumberChange(newValue: string) {
    let regex = new RegExp("^[+]((?!(0))[0-9]{0,15})$");
    if (!regex.test(newValue)) {
      this.message = this.translate.instant('ValidatePhoneNumberVts');
      return false;
    }

    this.message = '';
  }

  eventHandler(event: any) {
    console.log(event, event.keyCode, event.keyIdentifier);
    var regex = new RegExp("^[0-9a-zA-Z \b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  ngOnInit() {
    this.module = this.translate.instant('LblVtsVehicle');
    this.obuTypeList = [
      {
        Key: this.translate.instant('LblSelectObuType'),  // Key is shown to user
        Value: ''                                             // Value is send to api
      },
      {
        Key: 'Invers',
        Value: 'Invers'
      },
      {
        Key: 'BMW',
        Value: 'Bmw'
      },
      {
        Key: 'AXA',
        Value: 'Axa'
      },{
        Key: 'Teltonika',
        Value: 'Teltonika'
      } ];

    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVehicleList = this.authService.GetURL(ApplicationRouteURL.URL_VTSVEHICLE_LIST);
    this.model = new VTSVehicleModel();
    this.model.obuType = this.obuTypeList[0].Value;
    this.GetVehicleDetails();
  }

  onSubmit(forms: any) {
    this.isLoading = true;
    this.vehicleService.AddNewVtsVehicle(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant('LblRecordAddedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });

  }
  public formatLicenceTag(newVal: string) {
    var outputString = '';
    var chars: any = newVal.replace(/-/g, '').split('');
    if (!(chars.length > 0))
      return outputString;
    if (chars.length == 1)
      return chars[0];
    for (let i = 1; i < chars.length; i++) {
      outputString += chars[i - 1];
      if (chars[i - 1] == "-" || chars[i] == "-") {
        continue;
      }
      if (isNaN(chars[i - 1]) != isNaN(chars[i])) {
        outputString += "-";
      }
      if (i == chars.length - 1) {
        outputString += chars[i];
      }
    }
    console.log(outputString);
    return outputString;
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  public GetVehicleDetails() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.vehicleMasterHashId = params['id'] || '';
        if (this.vehicleMasterHashId != '') {
          this.isEditMode = true;
          this.isLoading = true;
          this.vehicleService.GetVtsVehicleByHashId(this.vehicleMasterHashId)
            .subscribe(
            res => {
              this.model = res.data;
              this.isLoading = false;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            });
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/components/vtsvehicle-update.component.ts